var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShedulle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.275 14.475L20.025 12.225C19.725 11.925 19.275 11.925 18.975 12.225L12 19.2V22.5H15.3L22.275 15.525C22.575 15.225 22.575 14.775 22.275 14.475ZM14.7 21H13.5V19.8L17.25 16.05L18.45 17.25L14.7 21ZM19.5 16.2L18.3 15L19.5 13.8L20.7 15L19.5 16.2ZM7.5 17.25H9V18.75H7.5V17.25ZM10.5 13.5H13.5V15H10.5V13.5ZM7.5 13.5H9V15H7.5V13.5ZM10.5 9.75H16.5V11.25H10.5V9.75ZM7.5 9.75H9V11.25H7.5V9.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 21V5.25H7.5V7.5H16.5V5.25H18.75V9.75H20.25V5.25C20.25 4.425 19.575 3.75 18.75 3.75H16.5V3C16.5 2.175 15.825 1.5 15 1.5H9C8.175 1.5 7.5 2.175 7.5 3V3.75H5.25C4.425 3.75 3.75 4.425 3.75 5.25V21C3.75 21.825 4.425 22.5 5.25 22.5H9V21H5.25ZM9 3H15V6H9V3Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShedulle);
export default __webpack_public_path__ + "static/media/Shedulle.7776282cb6b51169d13f3cf1d09f02fd.svg";
export { ForwardRef as ReactComponent };